export enum MutationTypes {
  SET_VM = 'SET_VM',
  SET_USER = 'SET_USER',
  SET_TOKEN = 'SET_TOKEN',
  SET_ORIGIN_URL = 'SET_ORIGIN_URL',
  SET_LOADING = 'SET_LOADING',
  SET_ACTIVE_LANG = 'SET_ACTIVE_LANG',
  SET_EDITORIAL_PROJECTS = 'SET_EDITORIAL_PROJECTS',
  SET_ELEMENT_TYPES = 'SET_ELEMENT_TYPES',
  SET_ELEMENT_STATUS_TYPES = 'SET_ELEMENT_STATUS_TYPES',
  SET_ELEMENT_STATUS_PHASES = 'SET_ELEMENT_STATUS_PHASES',
  SET_LOADING_STATUS_TYPES = 'SET_LOADING_STATUS_TYPES',
  SET_LOADING_STATUS_PHASES = 'SET_LOADING_STATUS_PHASES'
}
